import isEmpty from "lodash/isEmpty";
import * as React from "react";
import { FieldRenderProps } from "react-final-form";
import { ConditionalFieldOption, FormField } from "../../../index";
import { ConditionalFieldItem } from "./ConditionalFieldItem/ConditionalFieldItem";

export interface ConditionalComponentProps extends FieldRenderProps<any> {
  values?: object;
  conditionalFieldOptions: ConditionalFieldOption[];
}

export const ConditionalFieldComponent = (props: ConditionalComponentProps) => {
  const { conditionalFieldOptions, values, input } = props;

  return (
    <>
      {!isEmpty(values) &&
        conditionalFieldOptions.map(
          (option: ConditionalFieldOption, key: number) => (
            <div key={key}>
              {option.condition(values, input.name) &&
                option.fields.mapFields(
                  (field: FormField, index: number) => {
                    //todo Ambiguous behavior depending on usage. Should be fixed in future release
                    field.name = field.name || input.name;
                    return (
                      <ConditionalFieldItem
                        key={field.name + index}
                        field={field}
                        values={values}
                      />
                    );
                  },
                  { data: props.values }
                )}
            </div>
          )
        )}
    </>
  );
};
